import React, { useEffect, useRef, useState } from 'react';
import { Button, Empty } from '30pay/components';
import { AddCardNumberModal } from './addCardNumberModal/addCardNumberModal.index';
import { detectBank, detectBankByName, get, post } from 'scripts';
import { API } from 'data/30pay.api';
import { BankAccount } from 'interfaces';
import { BankIcon, ConfirmationModal } from 'utilities/components';
import Delete from 'assets/icons/Delete.svg';
import { Skeleton, Spin } from 'antd';
import { SiPayConfirmationModalRef } from 'utilities/components/confirmationModal/confirmationModal.index';
import { toast } from 'react-toastify';

export interface CardNumbersRef {
    reload: () => void;
}

export const CardNumbers = (props: CardNumbersRef) => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [data, setData] = useState<Omit<BankAccount, 'iBan'>[]>();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<Omit<BankAccount, 'iBan'> | undefined>();
    const confirmationModalRef = useRef<SiPayConfirmationModalRef>(null);
    function getData() {
        setData(undefined);
        get<Omit<BankAccount, 'iBan'>[]>(API.bankAccount.cardNumber)
            .then((e) => setData(e.value.value))
            .catch((e) => setData([]));
    }

    function deleteHandler() {
        if (isDeleteModalOpen?.id) {
            confirmationModalRef.current?.startLoading();
            post(API.bankAccount.removeCardNumber(isDeleteModalOpen?.id), {})
                .then((_) => {
                    toast.success('شماره کارت مورد نظر با موفقیت حذف شد');
                    getData();
                    setIsDeleteModalOpen(undefined);
                })
                .catch(() => console.log('Error'))
                .finally(() => confirmationModalRef.current?.stopLoading());
        }
    }

    useEffect(() => {
        getData();
    }, []);
    return (
        <div className="rounded-lg py-6 px-8 max-lg:py-5 max-lg:px-4 flex flex-col gap-8 flex-1 bg-white border border-primary-20 w-full">
            <ConfirmationModal
                isOpen={!!isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(undefined)}
                title="حذف کردن شماره کارت"
                message="شما قصد حذف کردن حساب بانکی خود را دارید."
                submitButtonText="حذف"
                onConfirm={deleteHandler}
                ref={confirmationModalRef}
            />
            <AddCardNumberModal
                isOpen={isAddModalOpen}
                onFinish={(body) => {
                    setIsAddModalOpen(false);
                    getData();
                    body.addIBan && props.reload();
                }}
                onClose={() => setIsAddModalOpen(false)}
            />
            <div className="w-full flex items-center">
                <h6 className="font-bold text-xl text-black-100">شماره کارت</h6>
                <span className="flex-1" />
                <Button onClick={() => setIsAddModalOpen(true)} className="!h-8 font-medium text-sm" type="primary">
                    افزودن شماره کارت
                </Button>
            </div>
            {data ? (
                data.length !== 0 ? (
                    <div className="bg-background rounded-lg flex flex-col">
                        <div className="h-[54px] flex items-center px-6">
                            <div className="h-full flex-1 flex items-center">
                                <label className="font-bold text-base text-darkPurple-100 max-lg:text-xs">
                                    نام بانک
                                </label>
                            </div>
                            <div className="h-full flex-[2] flex items-center">
                                <label className="font-bold text-base text-darkPurple-100 max-lg:text-xs">
                                    شماره کارت
                                </label>
                            </div>
                        </div>
                        {data.map((item, index) => {
                            const bankData = detectBank(item.cardNumber);
                            return (
                                <div key={index} className="h-[54px] flex items-center border-t border-primary-20 px-6">
                                    <div className="h-full flex-1 flex items-center gap-4">
                                        <BankIcon symbol={bankData?.bank_name} />
                                        <p className="font-bold text-base text-darkPurple-100 max-lg:text-xs">
                                            {bankData?.bank_title}
                                        </p>
                                    </div>
                                    <div className="h-full flex-[2] flex items-center">
                                        <p className="font-medium text-base text-darkPurple-100 max-lg:text-xs">
                                            {item.cardNumber}
                                        </p>
                                    </div>
                                    <div className="h-full flex items-center clickable">
                                        <img onClick={() => setIsDeleteModalOpen(item)} src={Delete} alt="delete" />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <Empty />
                )
            ) : (
                <div className="w-full h-full flex items-center justify-center min-h-[148px]">
                    <Skeleton />
                </div>
            )}
        </div>
    );
};
